import React, { useEffect, useState } from "react";
import { fetchHero } from "./HeroQuery";
import "../../styles/common.css";
import "./Hero.css";
import loader from "../../assets/loading.png";
const Hero = ({ setNavbarBg }) => {
  const [loading, setLoading] = useState(true);
  const [contentItems, setContentItems] = useState([]);

  const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

  const getUrl = (pathArray) => {
    if (!pathArray || pathArray.length === 0) return "";
    const path = pathArray[0];
    return path.startsWith("http")
      ? encodeURI(path)
      : encodeURI(`${BASE_URL}${path}`);
  };

  useEffect(() => {
    async function loadHero() {
      try {
        const data = await fetchHero();
        const items = data?.homePage?.[0]?.hero?.contentItems || [];
        setContentItems(items);
      } catch (error) {
        console.error("Error loading Hero:", error);
      } finally {
        setLoading(false);
      }
    }
    loadHero();
  }, []);

  const leftSection = contentItems.find(
    (item) => item.enabled && item.headLine
  );
  const rightSection = contentItems.find(
    (item) => item.enabled && item.title
  );


  const background = contentItems.find(
    (item) => item.enabled && (item.media || item.isVideo !== undefined)
  );

  const mediaUrl = getUrl(background?.media?.urls);
  const isVideo = background?.isVideo;

  
  useEffect(() => {
    if (setNavbarBg) {
      if (mediaUrl) setNavbarBg(`url(${mediaUrl})`);
      else setNavbarBg("transparent");
    }
  }, [mediaUrl, setNavbarBg]);

  
  if (loading) {
    return (
      <div className="hero-loader">
        <img src={loader} alt="Loading" className="loader-image" />
      </div>
    );
  }

  if (!contentItems.length) return null;


  return (
    <section className="hero-section" style={{ position: "relative" }}>
      
    
      {mediaUrl &&
        (isVideo ? (
          <video autoPlay muted loop playsInline className="hero-media">
            <source src={mediaUrl} type="video/mp4" />
          </video>
        ) : (
          <img src={mediaUrl} alt="Hero Background" className="hero-media" />
        ))}

      <div className="overlay"></div>

      <div className="hero-content">
        
        
        {leftSection && (
          <div className="hero-left">
            <h1 className="headline">{leftSection.headLine}</h1>
            <p className="tagline">{leftSection.tagLine}</p>

            <div className="hero-buttons">
              {leftSection.isCTA1 && (
                <a href={leftSection.cTA1.url} className="btn btn-CTA1">
                  {leftSection.cTA1.text}
                </a>
              )}

              {leftSection.isCTA2 && (
                <a href={leftSection.cTA2.url} className="btn btn-CTA2">
                  {leftSection.cTA2.text}
                </a>
              )}
            </div>
          </div>
        )}

        
        {rightSection && (
          <div className="hero-right">
            <p className="title">{rightSection.title}</p>
            <p className="opendays">{rightSection.openDays}</p>
            <p className="opentimes">{rightSection.openTimes}</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default Hero;
